module.exports = __webpack_public_path__ + "assets/4df3e42a3eb52b2c718e9a257a59bbdd.png";